import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Hourglass, SignOut } from "@phosphor-icons/react";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-6" data-testid="pending-approval-screen">
      <div className="w-full max-w-md bg-[#141414] border border-white/10 rounded-sm p-10 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#FF3B30]/10 mb-6">
          <Hourglass size={32} weight="fill" color="#FF3B30" />
        </div>
        <h1 className="font-head text-3xl font-black uppercase tracking-tighter mb-3">Awaiting Approval</h1>
        <p className="text-[#A3A3A3] mb-2">Hi {user?.name}, your account has been created.</p>
        <p className="text-[#A3A3A3] mb-8">Your Athletic Director needs to approve your request before you can access the hub. Please check back soon.</p>
        <button onClick={logout} data-testid="pending-logout-button"
          className="inline-flex items-center gap-2 border border-white/15 text-[#A3A3A3] hover:text-white hover:border-white/30 font-bold uppercase tracking-widest px-6 py-3 rounded-sm transition-colors">
          <SignOut size={18} weight="bold" /> Sign out
        </button>
      </div>
    </div>
  );
}
